exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbutton[data-v-2f7b560a] {\n  transition: opacity ease-in-out 0.2s;\n}\n.loading[data-v-2f7b560a] {\n  opacity: 0.5;\n}", ""]);

// exports
